import { render, staticRenderFns } from "./MeetingClosureModuleReviews.vue?vue&type=template&id=b403d2c6&"
import script from "./MeetingClosureModuleReviews.vue?vue&type=script&lang=js&"
export * from "./MeetingClosureModuleReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports